import { selectOptionFactory } from '../../../../utils';

export const UNSET_POLICY_OPTION = selectOptionFactory(null, 'Select policy');
